import { Component, OnInit } from '@angular/core';
import {Machinetype} from './machinetype';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { headersToString } from 'selenium-webdriver/http';
import { tokenKey } from '@angular/core/src/view';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { MachinetypeService } from './machinetypeService';

@Component({
  selector: 'app-machinetype',
  templateUrl: './machinetype.component.html',
  styleUrls: ['./machinetype.component.less']
})
export class MachinetypeComponent implements OnInit {
  machinetypes: Machinetype[]
  machinetype = new Machinetype
  private location: Location

constructor(private http: HttpClient,  private route: ActivatedRoute,private machinetypeservice: MachinetypeService) { }

  ngOnInit() {
    const id = +this.route.snapshot.paramMap.get('id');
    console.log(id);
    if (id == 0)
    {
      this.machinetypeservice.getMachinetypes().subscribe(machinetypes => this.machinetypes = machinetypes);
    } 
    else 
    this.machinetypeservice.getMachinetype(id).subscribe(machinetype => this.machinetype = machinetype);
   
  }


  save(): void {
    console.log(this.machinetype.type);
    this.machinetypeservice.updateMachinetype(this.machinetype)
      .subscribe();
  }
  
 getMachinetypeById(id: number)
 {
  this.machinetypeservice.getMachinetype(id).subscribe(machinetype => this.machinetype = machinetype);
  console.log("the machinetype is " + this.machinetype);
 }
  goBack(): void {
    this.location.reload;
  }
}
